import { useAuthQuery } from 'utils/hooks';
import { GET_COMPANY_PAYMENT_INFO } from 'apollo/queries';

export const useGetCompanyPaymentInfo = () => {
  const { data, refetch } = useAuthQuery(GET_COMPANY_PAYMENT_INFO);
  const { getCompanyInfo = {} } = { ...data };
  return { refetch, paymentInfo: getCompanyInfo };
};
